

(async()=>{
  const closedEl=document.getElementById('pp-folder-closed');
  const root=document.getElementById('pp-roscoe-sample');
  const folderObj=document.getElementById('pp-folder-object');
  if(!closedEl||!root||!folderObj) return;
  let assets;
  const island=root.querySelector('#pp-roscoe-assets');
  if(island && island.textContent && island.textContent.trim().length>20){
    assets=JSON.parse(island.textContent);
  } else {
    const url=root.getAttribute('data-assets-url');
    if(!url){ console.error('pp-roscoe: missing assets'); return; }
    const res=await fetch(url,{credentials:'same-origin'});
    if(!res.ok){ console.error('pp-roscoe: assets fetch failed', res.status); return; }
    assets=await res.json();
  }

  const ids=['R01','R02','R04','R05','R07','R08','R13','R14'];
  const opened=new Set();let current='R01';let hintLevel=0;let readerMode='page';let screen='desk';let readerReturn='desk';
  let folderState='closed';let openingTimer=null;
  const reduceMotion=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  const esc=s=>String(s).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const paragraphs=s=>s.split(/\n\s*\n/).map(t=>'<p>'+esc(t)+'</p>').join('');

  function showInvestigation(){
    closedEl.hidden=true;
    root.hidden=false;
    folderState='open';
    folderObj.classList.remove('is-opening');
    folderObj.classList.add('is-open');
  }
  function showClosed(){
    if(openingTimer){clearTimeout(openingTimer);openingTimer=null;}
    root.hidden=true;
    closedEl.hidden=false;
    folderState='closed';
    folderObj.classList.remove('is-opening','is-open');
    show('desk');
    closedEl.scrollIntoView({behavior:'auto',block:'start'});
  }
  function finishOpen(thenStory){
    showInvestigation();
    show(thenStory?'story':'desk');
    root.scrollIntoView({behavior:'auto',block:'start'});
  }
  function openFolder(skip, thenStory){
    if(folderState==='open'){finishOpen(thenStory);return;}
    if(folderState==='opening'&&!skip)return;
    if(skip||reduceMotion){
      if(openingTimer){clearTimeout(openingTimer);openingTimer=null;}
      folderObj.classList.add('is-open');
      folderObj.classList.remove('is-opening');
      finishOpen(thenStory);
      return;
    }
    folderState='opening';
    folderObj.classList.remove('is-open');
    folderObj.classList.add('is-opening');
    openingTimer=setTimeout(()=>{
      openingTimer=null;
      finishOpen(thenStory);
    },1000);
  }

  root.querySelectorAll('[data-asset]').forEach(img=>img.src=assets[img.dataset.asset].image);
  root.querySelector('[data-opening]').innerHTML=paragraphs(assets.scenes.opening.text);
  root.querySelector('[data-bounds]').textContent=assets.bounds;
  root.querySelector('[data-aftermath-text]').innerHTML=paragraphs(assets.scenes.aftermath.text);
  const grid=root.querySelector('[data-record-grid]');
  grid.innerHTML=ids.map(id=>'<button class="pp-record" type="button" data-record="'+id+'"><span class="pp-thumb" style="display:block"><img src="'+assets[id].image+'" alt="Original PDF page: '+esc(assets[id].title)+'"></span><span class="pp-record-name">'+esc(assets[id].title)+'</span><span class="pp-record-ref" data-open-label="'+id+'">'+id+' · open record</span></button>').join('');

  function show(name){
    screen=name;
    root.querySelectorAll('[data-screen]').forEach(el=>el.hidden=el.dataset.screen!==name);
    if(!root.hidden)root.scrollIntoView({behavior:'auto',block:'start'});
  }
  function blocks(ex){return ex.blocks.map(b=>{
    if(b.type==='fields')return '<dl class="pp-fields">'+b.rows.map(r=>'<dt>'+esc(r[0])+'</dt><dd>'+esc(r[1])+'</dd>').join('')+'</dl>';
    if(b.type==='table')return '<table class="pp-data-table"><thead><tr>'+b.headers.map(h=>'<th scope="col">'+esc(h)+'</th>').join('')+'</tr></thead><tbody>'+b.rows.map(r=>'<tr>'+r.map(c=>'<td>'+esc(c)+'</td>').join('')+'</tr>').join('')+'</tbody></table>';
    if(b.type==='sub')return '<h3>'+esc(b.text)+'</h3>';
    return '<p'+(b.type==='note'?' class="pp-read-note"':'')+'>'+esc(b.text)+'</p>';
  }).join('');}
  function mode(name){
    readerMode=name;
    root.querySelector('[data-reader-page]').hidden=name!=='page';
    root.querySelector('[data-reader-text]').hidden=name!=='text';
    root.querySelectorAll('[data-mode]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.mode===name)));
  }
  function openRecord(id){
    current=id;const ex=assets[id];readerReturn=id==='story'?'story':'desk';
    root.querySelector('[data-reader-title]').textContent=id==='story'?'Before the chisel':ex.title;
    root.querySelector('[data-reader-label]').textContent=(id==='story'?'Opening story':id)+' · PDF page '+ex.pdf_page;
    root.querySelector('[data-reader-page]').innerHTML='<img src="'+ex.image+'" alt="'+esc(id==='story'?'Before the chisel, original opening story':ex.title)+', original PDF page"><p class="pp-read-note">The page is reproduced from the finished case. Readable text preserves its words and fields.</p>';
    root.querySelector('[data-reader-text]').innerHTML=id==='story'?paragraphs(assets.scenes.opening.text):'<p class="pp-eyebrow">'+esc(ex.date)+'</p><p class="pp-read-note">'+esc(ex.source)+'</p>'+blocks(ex);
    if(ids.includes(id)){
      opened.add(id);
      root.querySelector('[data-read-count]').textContent=opened.size+' of 8 opened';
      const lab=root.querySelector('[data-open-label="'+id+'"]');
      if(lab)lab.textContent=id+' · opened';
      const btn=root.querySelector('.pp-record[data-record="'+id+'"]');
      if(btn)btn.classList.add('is-opened');
    }
    root.querySelector('[data-action="previous"]').hidden=id==='story'||ids.indexOf(id)===0;
    root.querySelector('[data-action="next"]').hidden=id==='story'||ids.indexOf(id)===ids.length-1;
    mode(readerMode);show('reader');
  }
  const hints=[
    'Begin with the cemetery index, R02. The reference beside a name tells you which book to check. Do the two G17 names refer to the same kind of record?',
    'Compare R04 with R05. Match the interment number, undertaker account, coffin seal, and destination together. Then use R13 to identify the relationship.',
    'R07 says whether a burial accompanied the original stone. R14 contains the later request and permission. Put their dates in order.'
  ];
  function hint(el){el.hidden=false;el.textContent=hints[Math.min(hintLevel++,hints.length-1)];}

  // Closed-folder controls (outside root)
  closedEl.addEventListener('click',event=>{
    const b=event.target.closest('button');if(!b||!closedEl.contains(b))return;
    switch(b.dataset.action){
      case 'open-folder':openFolder(false,false);break;
      case 'skip-animation':openFolder(true,false);break;
      case 'story-from-closed':openFolder(true,true);break;
    }
  });

  root.addEventListener('click',event=>{
    const b=event.target.closest('button');if(!b||!root.contains(b))return;
    if(b.dataset.record){openRecord(b.dataset.record);return;}
    if(b.dataset.mode){mode(b.dataset.mode);return;}
    switch(b.dataset.action){
      case 'desk':show(screen==='reader'?readerReturn:'desk');break;
      case 'back-folder':showClosed();break;
      case 'story':show('story');break;
      case 'story-page':openRecord('story');break;
      case 'answer':show('answer');break;
      case 'previous':openRecord(ids[Math.max(0,ids.indexOf(current)-1)]);break;
      case 'next':openRecord(ids[Math.min(ids.length-1,ids.indexOf(current)+1)]);break;
      case 'hint':hint(root.querySelector('[data-hint]'));break;
      case 'answer-hint':hint(root.querySelector('[data-answer-hint]'));break;
      case 'reveal-gate':root.querySelector('[data-reveal-gate]').hidden=false;break;
      case 'reveal':root.querySelector('[data-solution-status]').textContent='The solution';show('solution');break;
      case 'aftermath':root.querySelector('[data-aftermath]').hidden=false;root.querySelector('[data-aftermath]').scrollIntoView({behavior:'auto',block:'start'});b.hidden=true;break;
    }
  });
  root.querySelector('[data-answer-form]').addEventListener('submit',event=>{
    event.preventDefault();const data=new FormData(event.target);const f=root.querySelector('[data-feedback]');
    f.hidden=false;
    if(['occupant','relationship','explanation'].some(n=>!data.get(n))){f.textContent='Choose one answer for each of the three questions before checking your finding.';return;}
    const wrong=[];
    if(data.get('occupant')!=='miriam')wrong.push('Check the delivery chain: R04 and R05 must agree on the account, seal, and destination.');
    if(data.get('relationship')!=='mother')wrong.push('Read the parent fields in Roscoe’s marriage record, R13.');
    if(data.get('explanation')!=='memorial')wrong.push('Compare the original stone order, R07, with the later written instructions, R14.');
    if(wrong.length){f.textContent='The records do not support the whole finding yet. '+wrong.join(' ');return;}
    f.hidden=true;root.querySelector('[data-solution-status]').textContent='Your finding matches the records';show('solution');
  });

  // Auto-open for reduced motion preference on first paint? No — still show closed; open instantly when clicked.
  // Keyboard: Enter/Space already activate buttons.
})();
